@if (src()) {
  <img
    class="avatar__image"
    [src]="src()"
    [alt]="alt()"
  />
} @else if (label()) {
  <div
    class="avatar__inner"
    [style.background-color]="color()"
  >
    {{ label() }}
  </div>
}
